// extracted by mini-css-extract-plugin
export default {"container":"styles_container__TlvTt","title":"styles_title__3pEcv","typeMethod":"styles_typeMethod__2-cFx","btnContinue":"styles_btnContinue__SnoVC"};